<template>
  <KeepAlive>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    v-model="drawer"
    width="300"
    >
    <v-toolbar color="primary darken-1" dark>
      <img v-bind:src="computeLogo" height="16" alt="POH Admin">
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">POH Admin {{version}}</span>
      </v-toolbar-title>        
    </v-toolbar>
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-chip v-if="environment != false && environment != null && environment != ''" :class='{ "environment-chip": !!appLabel, "chip-test": environment.toLowerCase().includes("test"), "chip-prod": environment.toLowerCase().includes("production") }' label>
        <svg v-if="environment.toLowerCase().includes('test')" xmlns="http://www.w3.org/2000/svg" width="18" height="auto" fill="currentColor" class="bi bi-hammer chip-icon" viewBox="0 0 16 16">
          <path d="M9.972 2.508a.5.5 0 0 0-.16-.556l-.178-.129a5 5 0 0 0-2.076-.783C6.215.862 4.504 1.229 2.84 3.133H1.786a.5.5 0 0 0-.354.147L.146 4.567a.5.5 0 0 0 0 .706l2.571 2.579a.5.5 0 0 0 .708 0l1.286-1.29a.5.5 0 0 0 .146-.353V5.57l8.387 8.873A.5.5 0 0 0 14 14.5l1.5-1.5a.5.5 0 0 0 .017-.689l-9.129-8.63c.747-.456 1.772-.839 3.112-.839a.5.5 0 0 0 .472-.334"/>
        </svg>
        <svg v-if="environment.toLowerCase().includes('production')" xmlns="http://www.w3.org/2000/svg" width="16" height="auto" fill="currentColor" class="bi bi-airplane-fill chip-icon" viewBox="0 0 16 16">
           <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849"/>
        </svg>
        {{appLabel}} : {{environment}}
      </v-chip>   
      <v-list dense expand>
        <template v-for="(item, i) in menus">
            <!--group with subitems-->
            <v-list-group v-if="item.items" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <v-list-tile v-else :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                  </v-list-tile-content>
                  <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                  <v-list-tile-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
              <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
            </v-list-tile>
        </template>
      </v-list>     
    </vue-perfect-scrollbar>        
  </v-navigation-drawer>
  </KeepAlive>
</template>
<script>
import menu from '@/api/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  name: 'app-drawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    mini: false,
    drawer: true,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160
    }    
  }),
  computed: {
    version(){
      console.log('version: ' + this.$store.state.version);
      return this.$store.state.version;
    }, 
    environment(){
      return this.$store.state.environment;
    }, 
    computeGroupActive () {
      return true;
    },
    computeLogo () {
      return './static/pg-logo.svg';
    },
    appLabel() {
      return this.$store.state.appLabel;
    },
    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    }    
  },
  created () {
    window.getApp.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    });
  },
  

  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${(subItem.name)}` };
    },
  }
};
</script>


<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

.v-chip.environment-chip.v-chip--label.theme--light {
  margin-top: 1em;
  margin-left: 16px;
  width: 100%;
  background: #3f51b5;
  color: white;
}

.v-chip.environment-chip.chip-test.v-chip--label.theme--light {
  margin-top: 1em;
  margin-left: 16px;
  width: 100%;
  background: #bbbdbb;
  background-image: none;
  background-size: auto;
  color: #fff;
  background-image: linear-gradient(45deg, #383838 41.67%, #616161 41.67%, #616161 50%, #383838 50%, #383838 91.67%, #616161 91.67%, #616161 100%);
  background-size: 16.97px 16.97px;
}

.v-chip.environment-chip.chip-prod.v-chip--label.theme--light {
  margin-top: 1em;
  margin-left: 16px;
  width: 100%;
  background: #bbbdbb;
  background-image: none;
  background-size: auto;
  color: #fff;
  background-image: linear-gradient(45deg, #3f51b5 41.67%, #6777cf 41.67%, #6777cf 50%, #3f51b5 50%, #3f51b5 91.67%, #6777cf 91.67%, #6777cf 100%);
  background-size: 16.97px 16.97px;
}

.chip-icon {
  margin-right: 6px;
}

#appDrawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto

</style>



// WEBPACK FOOTER //
// src/components/AppDrawer.vue